import React from 'react';
import { Icon } from '@iconify/react';
import lineIcon from '@iconify-icons/simple-icons/line';
import pinterestIcon from '@iconify-icons/simple-icons/pinterest';
import XIcon from '@mui/icons-material/X';
import facebookIcon from '@iconify-icons/simple-icons/facebook';
import instagramIcon from '@iconify-icons/simple-icons/instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';

interface SocialMediaIconsProps {
  color: string;
}

export default function SocialMediaIcons({ color = 'black' }: SocialMediaIconsProps): JSX.Element {
  return (
    <div className="flex items-center gap-x-6 max-md:pt-12">
      <a href="https://www.youtube.com/@renovefudosan_com" target="_blank" rel="noopener noreferrer">
        <YouTubeIcon sx={{ width: 32, height: 32 }} className={`text-${color} hover:text-sns-youtube`} />
      </a>
      <a href="https://x.com/renovefudosan_c" target="_blank" rel="noopener noreferrer">
        <XIcon className={`w-6 h-6 hover:opacity-60 ${color === 'white' ? 'text-white' : ''}`} />
      </a>
      <a
        href="https://www.facebook.com/renovefudosan/"
        target="_blank"
        rel="noopener noreferrer"
        className={`text-${color} hover:text-sns-facebook`}
      >
        <Icon icon={facebookIcon} className="w-6 h-6" />
      </a>
      <a
        href="https://www.instagram.com/renovefudosan/"
        target="_blank"
        rel="noopener noreferrer"
        className={`text-${color} hover:text-sns-instagram`}
      >
        <Icon icon={instagramIcon} className="w-6 h-6" />
      </a>
      <a
        href="https://page.line.me/ics6023v?openQrModal=true"
        target="_blank"
        rel="noopener noreferrer"
        className={`text-${color} hover:text-sns-line`}
      >
        <Icon icon={lineIcon} className="w-6 h-6" />
      </a>
      <a
        href="https://www.pinterest.jp/renovefudosan/"
        target="_blank"
        rel="noopener noreferrer"
        className={`text-${color} hover:text-sns-pinterest`}
      >
        <Icon icon={pinterestIcon} className="w-6 h-6" />
      </a>
    </div>
  );
}
